import Banner from '../banner/index.js'
import laptop_vector from'../../../assets/images/laptop_vector.png'
import floating_1 from'../../../assets/images/floating_1.png'
import floating_2 from'../../../assets/images/floating_2.png'
import floating_3 from'../../../assets/images/floating_3.png'
import './style.css'

function Header() {
    return (
        <section className='header'>
            <div className='header-bg'>
                <div className="laptop-img hide-mobile">
                    <img src={ laptop_vector } id="laptop" alt="Laptop" />
                    <img src={ floating_1 } id="floating-1" alt="Floating 1" />
                    <img src={ floating_2 } id="floating-2" alt="Floating 2" />
                    <img src={ floating_3 } id="floating-3" alt="Floating 3" />
                </div>
            </div>
            <Banner />
        </section>
    )
}

export default Header;